import { useDispatch } from "react-redux";
import type { AppDispatch } from "./index";

/**
 * Thunk-aware `dispatch` hook.
 *
 * react-redux v9's `useDispatch()` returns `Dispatch<UnknownAction>`, which rejects thunk action creators
 * (v7's `Dispatch<any>` silently accepted them). This binds the hook to the store's real `AppDispatch` (a
 * `ThunkDispatch`) once, centrally, instead of each call site passing `useDispatch<AppDispatch>()`. The
 * returned hook takes no type argument — the type is already applied.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
